// extracted by mini-css-extract-plugin
export var field = "Textarea-module--field--2-3lZ";
export var textareaOnSurface = "Textarea-module--textareaOnSurface--2nUay";
export var show = "Textarea-module--show--2OXnP";
export var showFadeInDown = "Textarea-module--show-fade-in-down--aumtV";
export var showFadeInUp = "Textarea-module--show-fade-in-up--2flg_";
export var hideFadeOut = "Textarea-module--hide-fade-out--2YYIG";